// Hover-to-play logic for service videos
document.addEventListener('DOMContentLoaded', () => {
  const hoverVideos = document.querySelectorAll('.hover-video');

  hoverVideos.forEach((video) => {
    // Desktop hover
    video.addEventListener('mouseenter', () => {
      video.currentTime = 0;
      video.play().catch(() => {});
    });

    video.addEventListener('mouseleave', () => {
      video.pause();
      video.currentTime = 0;
    });

    // Mobile tap: toggle play / pause
    video.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
  });
});
// Catalog Filtering Script
document.addEventListener("DOMContentLoaded", () => {
  const filterButtons = document.querySelectorAll(".filter-tag");
  const items = document.querySelectorAll(".catalog-item");

  filterButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      
      // update active styling
      filterButtons.forEach((b) => b.classList.remove("active"));
      btn.classList.add("active");

      const filter = btn.dataset.filter;

      items.forEach((item) => {
        const categories = item.dataset.category.split(" ");

        if (filter === "all" || categories.includes(filter)) {
          item.style.display = "flex"; // show item
        } else {
          item.style.display = "none"; // hide item
        }
      });
    });
  });
});
function toggleMobileMenu() {
  let menu = document.getElementById("mobileMenu");
  menu.style.display = (menu.style.display === "flex") ? "none" : "flex";
}
document.addEventListener("DOMContentLoaded", () => {
  const url = window.location.href;

  if (url.includes("contact_posted=true")) {
    const successBox = document.getElementById("contactSuccess");
    if (successBox) {
      successBox.classList.add("active");
      window.scrollTo({ top: successBox.offsetTop - 120, behavior: "smooth" });
    }
  }
});
